import { FC, memo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { media } from '~src/styles/media-templates';
import { KeyTextI } from '~src/interfaces/translate.interface';
import { PageContentContainer } from '~src/styles/containers.sc';

const HeaderContainer = styled.header`
  border-bottom: 1px solid ${({ theme }) => theme.black.a1};
`;

const ContentContainer = styled(PageContentContainer)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleContainer = styled.div`
  padding: 60px 30px 30px 0;
  ${media.tablet`
    padding: 30px 30px 20px 0;
  `}
`;

const Title = styled.h1`
  font-size: 2.33rem;
`;

const Description = styled.div`
  max-width: 825px;
  font-size: 1rem;
  color: ${({ theme }) => theme.baseBlue.a6};
  margin-top: 5px;
`;

const RightCol = styled.div`
  margin-left: 30px;
`;

interface Props {
  title: KeyTextI;
  descr: KeyTextI;
}

const PageHeader: FC<Props> = memo(props => {
  const [t] = useTranslation();

  return (
    <HeaderContainer>
      <ContentContainer>
        <TitleContainer>
          <Title data-translation={props.title.key}>{props.title.txt || t(props.title.key)}</Title>
          <Description data-translation={props.descr.key}>
            {props.descr.txt || t(props.descr.key)}
          </Description>
        </TitleContainer>
        {props.children && <RightCol>{props.children}</RightCol>}
      </ContentContainer>
    </HeaderContainer>
  );
});
export default PageHeader;
